import { Typography } from '@mui/material';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box } from '@eatclubcode/ec-component-library';
import DatePicker from '../../../components/datePicker/DatePicker';
import useStyles from '../../../components/layout/appHeader/HeaderStyles';
import { isEmpty } from '../../../utils/baseHelpers';
import Mixpanel from '../../../lib/mixpanel';

const CustomerValueHeader = ({ firstBookingDate, fetchingDetailedInsight }) => {
  const classes = useStyles();

  const monthsSinceFirstBooking = dayjs().diff(firstBookingDate, 'month');

  const isTooNew =
    !fetchingDetailedInsight && (isEmpty(firstBookingDate) || monthsSinceFirstBooking < 2);

  // Limit date ranges if the venue is relatively new
  const dateRanges = useMemo(() => {
    return [
      { name: 'Last 1 Month', value: '1_month' },
      (isEmpty(firstBookingDate) || monthsSinceFirstBooking >= 1) && {
        name: 'Last 3 Months',
        value: '3_months',
      },
      (isEmpty(firstBookingDate) || monthsSinceFirstBooking >= 3) && {
        name: 'Last 6 Months',
        value: '6_months',
      },
      // (isEmpty(firstBookingDate) || monthsSinceFirstBooking >= 6) && {
      //   name: 'Last 12 Months',
      //   value: '1_year',
      // },
    ].filter((item) => !!item);
  }, [firstBookingDate, monthsSinceFirstBooking]);

  return (
    <Box style={{ width: '100%' }}>
      <Box className={classes.titleContainer}>
        <Box
          style={{
            display: 'flex',
            gap: '24px',
            flexWrap: 'wrap',
            alignItems: 'center',
          }}
        >
          <Box style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant='h1' className={classes.title}>
              Customer value
            </Typography>
          </Box>
        </Box>

        {!isTooNew && (
          <Box
            style={{
              display: 'flex',
              gap: '8px',
              flexWrap: 'wrap',
            }}
          >
            <DatePicker
              dateRangeInput={dateRanges}
              onDateRangeChange={(dateRange) => {
                Mixpanel.track('Customer insights window adjusted', { date_range: dateRange });
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

CustomerValueHeader.propTypes = {
  firstBookingDate: PropTypes.string,
};

const mapStateToProps = (state) => ({
  firstBookingDate: state.analytics.detailedInsight?.firstBookingDate,
  fetchingDetailedInsight: state.analytics.fetchingDetailedInsight,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CustomerValueHeader);
